import { generateGlobalCSS } from './createTheme'

export const injectInteliblyCSS = () => {
  if (document.getElementById('intelibly-global-css')) {
    return
  }

  const style = document.createElement('style')
  style.id = 'intelibly-global-css'
  style.textContent = generateGlobalCSS()

  document.head.appendChild(style)
}
